/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { BrowserRouter, useLocation } from "react-router-dom";
import { ThemeProvider } from "styled-components";
import { AuthProvider } from "./contexts/UserContext";
import { SidebarFiltrosProvider } from "./contexts/SidebarFiltrosContext";
import { SidebarProvider } from "./contexts/SidebarContext";
import { ThemeModeProvider, useThemeMode } from "./contexts/ThemeContext";
import Routes from "./routes";
import { GlobalStyles } from "./styles/Global";
import { getTheme } from "./styles/Themes";
import DarkModeToggle from "./components/DarkModeToggle";

// Telas externas (fluxo de acesso + telas fullscreen): SEMPRE dark (dark-only),
// igual ao EasyJur OS. Independem do toggle do app interno.
const EXTERNAL_PREFIXES = [
  "/login",
  "/recuperar-senha",
  "/cadastrar",
  "/cadastro-completo",
  "/registro-solicitante",
  "/solicitarservico",
  "/servico-completo",
  "/mcp/login",
  "/operador/concluir",
  "/proposta/concluir",
];

function isExternalPath(pathname: string): boolean {
  const p = (pathname || "").toLowerCase();
  return EXTERNAL_PREFIXES.some((x) => p === x || p.startsWith(x + "/") || p.startsWith(x));
}

// Conteúdo do app: resolve PERFIL (comum/admin/operador) × MODO (light/dark).
function AppContent() {
  const [tema, setTema] = useState<string>("comum");
  const { mode } = useThemeMode();
  const location = useLocation();

  const external = isExternalPath(location.pathname);
  const effectiveMode = external ? "dark" : mode;

  useEffect(() => {
    getUser();
  }, []);

  // Reflete o modo efetivo no <html> p/ CSS variables, statusColors e DS.
  useEffect(() => {
    try {
      document.documentElement.setAttribute("data-theme", effectiveMode);
      document.documentElement.setAttribute("data-ds-theme", effectiveMode);
    } catch (_) {
      /* ignore */
    }
  }, [effectiveMode]);

  async function getUser() {
    var storedArray = await localStorage.getItem("@Jj:user");
    if (storedArray === null) {
      return setTema("comum");
    }
    const ourArray = JSON.parse(storedArray as any);
    setTema(ourArray?.profile ?? "comum");
  }

  return (
    <ThemeProvider theme={getTheme(tema, effectiveMode)}>
      <Routes setTema={setTema} />
      {/* ⚠️ TEMPORÁRIO: toggle de tema (oculto nas externas dark-only) */}
      {!external && <DarkModeToggle />}
      <GlobalStyles />
    </ThemeProvider>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <SidebarFiltrosProvider>
          <SidebarProvider>
            <ThemeModeProvider>
              <AppContent />
            </ThemeModeProvider>
          </SidebarProvider>
        </SidebarFiltrosProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
